require(['jquery'], function ($) {
	// Hide header nav menu options
	$('.not-rewards-incentives .level-top').each(function() {
		if ($(this).text().includes('ewards')) {
			$(this).hide();	
		}	
	});
	$('.rewards-incentives .level-top').each(function() {
		if (!$(this).text().includes('ewards')) {
			$(this).hide();	
		}	
	});
	// Move search input next to button
	$('.desktop .search input').detach().insertAfter('.desktop .search .button').addClass('newsearch');
	// Strong tags in homepage boxes render HTML 
	$(".section-title").each(function() {
		$(this).html( $(this).text() );
	});
	// Remove "Br" /paragraph tag that gets injected into homepage box and add url to featured homepage boxes
	$(".homepage-box .page-content").each(function() {
		let getBoxUrl = $(this).find('a');
		let boxHref = getBoxUrl.attr('href');
		getBoxUrl.remove();
		$(this).parent().wrap('<a href="' + boxHref + '"/>');
		$(this).find('img').detach().appendTo($(this));
		//detach().appendTo($(this));
	});
	$(".homepage-box p").remove();
	$(".homepage-box br").remove();
	// Insert hero bar into category listing
	if ($(".xm-grid-category").length) {
		let categoryTitle = $(".category-title").html();
		$(".category-title").remove();
		$(".xm-grid-category .grid-group-1").append("<div class='hero-bar grid-container-wrapper col-main grid12-12 in-col1'>" + categoryTitle + "</div>");
	}
	// make inputs a number
	$(".qty-box").prop("type", "number");
	$( document ).ajaxComplete(function() {
		$(".qty-box").prop("type", "number");
		console.log('hsafsdf');
	});
	// Hide empty sidebar on category grid
	if ( (".xm-grid-category").length ) {
		$(".grid-container-wrapper").each(function() {
			if ($(this).text().trim() == 'Select') {
				$(this).hide();
				$(this).next().addClass('grid12-12').removeClass('grid12-9');	
			}
		});
	}
	// Move category-first-item to first in list
	if ( (".xm-grid-category").length && $(".category-first-item").length ) {
		let catFirstItemHtml = $(".category-first-item").html();
		$(".category-products-listing .item").first().clone().prependTo(".category-products-listing").html(catFirstItemHtml).addClass('category-first-item-li');
		let catHeightWithPadding = $(".category-products-listing .item").first().next().innerHeight();
		let catHeight = $(".category-first-item-li").innerHeight();
		console.log("catHeight is " + catHeight);
		let newCatPadding = (catHeightWithPadding-catHeight)/2;
		console.log("new cat padding " + newCatPadding);
		$(".category-first-item-li .page-content").css('padding',newCatPadding + 'px 0');
	}
});